import React from "react";
import { useQuery } from "@apollo/client";

import { GET_CITY_BY_STATE } from "../../Graphql/queries/queryGetCityByState";
import { LoadingScreen } from "../../components/StatusScreens/LoadingScreen";
import { RoutesNames } from "../../components/utils/routes";
import { useToastError } from "../../Hooks/useToastError";

import {
  ContainerGlobal,
  HeadContainer,
  ContainerInfo,
  DivInfo,
  BackButton,
  ContainerBack,
  TextBack,
} from "../../styles/PageStyles/ServicesGuide/DirectoryStyles";

const DirectoryMunicipalities = () => {
  const { error, data, loading } = useQuery(GET_CITY_BY_STATE, { variables: { stateId: 2890 } });
  useToastError(error);

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <ContainerGlobal>
      <BackButton href={RoutesNames.serviceGuide}>
        <ContainerBack>
          <TextBack>Volver</TextBack>
        </ContainerBack>
      </BackButton>
      <HeadContainer>
        <DivInfo> Municipio </DivInfo>
        <DivInfo> Correo Electrónico Institucional </DivInfo>
        <DivInfo> Teléfono </DivInfo>
      </HeadContainer>
      {data?.getCitiesByState.data.map((item, index) => (
        <ContainerInfo key={index}>
          <DivInfo>{item.name}</DivInfo>
          <DivInfo>{item.email}</DivInfo>
          <DivInfo>{item.phone}</DivInfo>
        </ContainerInfo>
      ))}
    </ContainerGlobal>
  );
};

export default DirectoryMunicipalities;
